import { render } from "./PieChart.vue?vue&type=template&id=35e80e2e&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=35e80e2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e80e2e"]])

export default __exports__